import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  proList: [],
  proPagination: {},
  loading: false,
  error: null,

  isLoading: false,
  proProfile: null,
  proProfileLoading: false,
  careDetail: {},
  videoDeleteSuccess: null,
  profilePagination: {},
  profileList: [],
};

const manageProsSlice = createSlice({
  name: "managePros",
  initialState,
  reducers: {
    proListLoad(state) {
      state.isLoading = true;
      state.addCareSuccess = false;
      state.deleteCareSuccess = false;
    },
    proListSuccess(state, action) {
      const { list = [], pagination = {}, proDashboard = {} } = action.payload;
      state.isLoading = false;
      state.proList = list;
      state.proPagination = pagination;
      state.proDashboard = proDashboard;
    },
    proListFail(state) {
      state.isLoading = false;
      state.error = true;
    },

    updateProStatusLoad(state) {
      state.loading = true;
    },
    updateProStatusSuccess(state, action) {
      state.loading = false;
    },
    updateProStatusFail(state) {
      state.loading = false;
      state.error = true;
    },
    proProfileLoad(state) {
      state.proProfileLoading = true;
      state.proProfile = null;
    },
    proProfileSuccess(state, action) {
      state.proProfileLoading = false;
      state.proProfile = action.payload;
    },
    proProfileFail(state) {
      state.proProfileLoading = false;
      state.error = true;
    },
    profileListLoad(state) {
      state.isLoading = true;
    },
    profileListSuccess(state, action) {
      const { list = [], pagination = {}, slotDashboard = {} } = action.payload;
      state.isLoading = false;
      state.profileList = list;
      state.profilePagination = pagination;
    },
    profileListFail(state) {
      state.isLoading = false;
      state.error = true;
    },

    videoDeleteLoad: (state) => {
      state.isLoading = true;
      state.videoDeleteSuccess = false;
    },
    videoDeleteSuccess: (state) => {
      state.isLoading = false;
      state.videoDeleteSuccess = true;
    },
    videoDeleteFailed: (state) => {
      state.isLoading = false;
    },
  },
});

export const {
  profileListSuccess,
  profileListLoad,
  profileListFail,
  proListLoad,
  proListSuccess,
  proListFail,
  updateProStatusLoad,
  updateProStatusSuccess,
  updateProStatusFail,
  proProfileLoad,
  proProfileSuccess,
  proProfileFail,
  videoDeleteLoad,
  videoDeleteSuccess,
  videoDeleteFailed,
} = manageProsSlice.actions;

export default manageProsSlice.reducer;
